module.exports = __webpack_public_path__ + "static/media/hamburger.2d042ae4.svg";